import { PublishedWorkEditWorkloadImpact } from '@/viewmodels';
import { WorkloadStatus } from '@buf/studyo_studyo-today-schools.bufbuild_es/studyo/today/schools/v1/resources/workload_status_pb';
import { List, Popover, Stack } from '@mui/material';
import { SxProps } from '@mui/system';
import { observer } from 'mobx-react-lite';
import LocalizedStrings from 'strings';
import { FormPopoverActions, FormPopoverHeader } from '../../utils';
import { PublishedWorkEditWorkloadImpactIndicatorPopoverSection } from './PublishedWorkEditWorkloadImpactIndicatorPopoverSection';

export interface PublishedWorkEditWorkloadImpactIndicatorPopoverProps {
  sx?: SxProps;
  className?: string;
  workloadImpact: PublishedWorkEditWorkloadImpact;
  anchorEl: HTMLElement | null;
  isOpen: boolean;
  onClose: () => void;
}

export const PublishedWorkEditWorkloadImpactIndicatorPopover = observer(
  ({
    sx = [],
    workloadImpact,
    isOpen,
    onClose,
    className,
    anchorEl
  }: PublishedWorkEditWorkloadImpactIndicatorPopoverProps) => {
    const strings = LocalizedStrings.publishedWork.edit;

    return (
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={() => onClose()}
        slotProps={{ paper: { sx: { width: 320 } } }}
        sx={sx}
        className={className}
      >
        <FormPopoverHeader title={strings.workloadImpactDetailsPopoverTitle()} />

        <List dense>
          <Stack spacing={2}>
            {workloadImpact.aboveThresholdStudents.length > 0 && (
              <PublishedWorkEditWorkloadImpactIndicatorPopoverSection
                status={WorkloadStatus.ABOVE_THRESHOLD}
                students={workloadImpact.aboveThresholdStudents}
              />
            )}

            {workloadImpact.atThresholdStudents.length > 0 && (
              <PublishedWorkEditWorkloadImpactIndicatorPopoverSection
                status={WorkloadStatus.AT_THRESHOLD}
                students={workloadImpact.atThresholdStudents}
              />
            )}
          </Stack>
        </List>

        <FormPopoverActions
          onSubmit={() => {
            onClose();
            return Promise.resolve();
          }}
          canSubmit
          customSubmitTitle={'Close'}
        />
      </Popover>
    );
  }
);
